import { create } from 'zustand'
import type { User } from '../types/auth'

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  setUser: (user: User) => void
  updateUser: (user: User) => void
  logout: () => void
}

function _loadUser(): User | null {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return null
    const user = JSON.parse(raw) as User
    // Basic sanity check: ensure required fields exist
    if (!user || !user.id || !user.username) {
      localStorage.removeItem('user')
      return null
    }
    return user
  } catch {
    localStorage.removeItem('user')
    return null
  }
}

const _initialUser = _loadUser()

export const useAuthStore = create<AuthState>((set) => ({
  user: _initialUser,
  isAuthenticated: !!_initialUser,

  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user))
    set({ user, isAuthenticated: true })
  },

  updateUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user))
    set({ user })
  },

  logout: () => {
    localStorage.removeItem('user')
    set({ user: null, isAuthenticated: false })
  },
}))
